import * as React from "react";

import {
  useTheme,
  Box,
  Stack,
  Typography,
  useMediaQuery,
  Button,
} from "@mui/material";
import kda_bold from "../images/kda_bold.jpg";

const EducationSection = ({}) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down(1000));
  const mobileScreen = useMediaQuery(theme.breakpoints.down(1000));

  return (
    <Stack
      name={"studies"}
      sx={{
        bgcolor: theme.palette.common.white,
        pt: "3rem",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Oswald', sans-serif",
          fontWeight: 700,
          fontSize: smallScreen ? "18px" : "32px",
          color: theme.palette.primary.main,
          textAlign: "center",
          px: "10vw",
          mb: "5rem",
        }}
      >
        What I studied till now
      </Typography>
      <Stack
        direction={"row"}
        sx={{
          width: "100%",
          minWidth: "200px",
          justifyContent: "space-between",
          alignItems: "flex-start",
          p: "2rem",
          flexWrap: "wrap",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: smallScreen ? "95%" : "50%",
            borderRadius: "10px",
            overflow: "hidden",
            //border: `3px solid ${theme.palette.common.black}`,
            height: "max-content",
          }}
        >
          <img
            src={kda_bold}
            alt="kda"
            style={{
              width: "100%",
              // clipPath: "polygon(0 0, 42% 0, 58% 100%, 0 100%)",
            }}
          />
        </Box>
        <Stack
          sx={{
            px: "2rem",
            pb: "2rem",
            bgcolor: theme.palette.common.white,
            width: smallScreen ? "95%" : "50%",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Oswald', sans-serif",
              fontWeight: 600,
              fontSize: "28px",
              mb: "2rem",
              mt: smallScreen ? "2rem" : undefined,
            }}
          >
            Just a software Engineer Career
          </Typography>
          <Typography
            sx={{
              color: theme.palette.grey[600],
              fontWeight: theme.typography.fontWeightRegular,
              fontSize: "14px",
            }}
          >
            All of my studies were marked by the Kinshasa Digital Academy where
            I learnt all of that I am proud to have done. Currently I am a
            detentor of a Bac+2 European certification and completed many other
            training programs online in various fields like global economy,
            financial markets, Big Data, technical trading Analysis, statistics;
            AI/ML and so on.
            <br />
            <br />
            Learning is my second way to breath, so I will stop the day my life
            will end up. I still learn many other aspects of Software
            Engineering like Devops, System design and Architecture, OLAP
            systems with a particular interest into financial market and Fintech
            in general.
            <br />
            <br />I will remember forever these kind, gorgeous and bright
            collegues, together we were at the Kinshasa Digital Academy learning
            the formulas of professional success and I hope they are flying now
            over the worlds of their dreams
          </Typography>
          <a
            target={"_blank"}
            rel="noreferrer"
            href="https://kinshasadigital.academy"
            style={{
              textDecoration: "none",
            }}
          >
            <Button
              sx={{
                background: "transparent",
                borderRadius: "70px",
                border: `2px solid ${theme.palette.primary.main}`,
                px: mobileScreen ? "0.5rem" : "1.3rem",
                py: mobileScreen ? "0.2rem" : ".7rem",
                transition: "all .3s",
                transform: "translateY(-10px)",
                mt: "1.5rem",
                color: theme.palette.primary.main,
                width: "max-content",
                "&:hover": {
                  transition: "all .3s",
                  transform: "translateY(-5px)",
                  color: theme.palette.whiteColor.main,
                  bgcolor: theme.palette.primary.main,
                },
                textTransform: "none",
                fontSize: "14px",
                fontWeight: theme.typography.fontWeightBold,
              }}
            >
              Discover the KDA
            </Button>
          </a>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default EducationSection;
